/* ============================================================
   MYPRIDE CULT — Infinite loop carousel, manual drag + momentum
   ============================================================ */

(function () {
  'use strict';

  /* ---------- looping: clone children to both sides ---------- */
  function initLoop(rail, row) {
    var children = Array.prototype.slice.call(row.children);
    var fragEnd = document.createDocumentFragment();
    var fragStart = document.createDocumentFragment();
    children.forEach(function (child) {
      fragEnd.appendChild(child.cloneNode(true));
      fragStart.appendChild(child.cloneNode(true));
    });
    row.appendChild(fragEnd);
    row.insertBefore(fragStart, row.firstChild);
  }

  function getHalf(row) {
    var children = Array.prototype.slice.call(row.children);
    var count = children.length;
    if (count === 0) return 0;
    var totalWidth = 0;
    for (var i = 0; i < children.length; i++) {
      totalWidth += children[i].offsetWidth;
    }
    var gap = parseFloat(getComputedStyle(row).gap) || 0;
    totalWidth += gap * (children.length - 1);
    return totalWidth / 3;
  }

  function checkBoundary(rail, half) {
    if (half <= 0) return;
    if (rail.scrollLeft >= half * 2) {
      rail.scrollLeft -= half;
    } else if (rail.scrollLeft < 0) {
      rail.scrollLeft += half;
    }
  }

  /* ---------- manual drag-to-scroll with momentum + infinite loop ---------- */
  function initDragScroll(rail, row) {
    var down = false;
    var moved = false;
    var startX = 0, startY = 0;
    var lastX = 0, lastTime = 0, velocity = 0;
    var samples = [];
    var animFrame = null;
    var DRAG_THRESHOLD = 6;
    var FRICTION = 0.9;
    var MAX_VEL = 80;
    var MOMENTUM_TRIGGER = 2.5;

    function cancelMomentum() {
      if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
    }

    function momentumStep() {
      rail.scrollLeft -= velocity;
      velocity *= FRICTION;
      checkBoundary(rail, getHalf(row));
      if (Math.abs(velocity) > 0.3) {
        animFrame = requestAnimationFrame(momentumStep);
      } else {
        animFrame = null;
        rail.classList.remove('dragging');
        snapToNearest();
      }
    }

    /* cancel the click that follows a drag so links don't open after dragging */
    function onRailClick(e) {
      if (moved) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }

    /* after drag/momentum, land on the nearest card */
    function snapToNearest() {
      var cards = row.querySelectorAll('.mypride-cult__card');
      var target = rail.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var off = cards[i].offsetLeft;
        var dist = Math.abs(off - target);
        if (dist < bestDist) { bestDist = dist; best = off; }
      }
      rail.scrollTo({ left: best, behavior: 'smooth' });
    }

    function onMove(e) {
      if (!down) return;
      var now = performance.now();
      var dx = e.clientX - lastX;
      var dt = now - lastTime;
      if (dt > 0) {
        samples.push(dx);
        if (samples.length > 4) samples.shift();
      }
      if (Math.abs(e.clientX - startX) > DRAG_THRESHOLD || Math.abs(e.clientY - startY) > DRAG_THRESHOLD) {
        moved = true;
      }
      lastX = e.clientX;
      lastTime = now;
      rail.scrollLeft -= dx;
      checkBoundary(rail, getHalf(row));
    }

    function endDrag() {
      if (!down) return;
      down = false;

      if (moved && samples.length > 1) {
        var total = 0;
        for (var i = 0; i < samples.length; i++) total += samples[i];
        velocity = total / samples.length;
        if (Math.abs(velocity) >= MOMENTUM_TRIGGER) {
          velocity = Math.max(-MAX_VEL, Math.min(MAX_VEL, velocity));
          rail.classList.add('dragging');
          animFrame = requestAnimationFrame(momentumStep);
          return;
        }
      }

      samples = [];
      rail.classList.remove('dragging');
      if (moved) {
        moved = false;
        snapToNearest();
      }
    }

    function onUp() { endDrag(); }
    function onCancel() { endDrag(); }

    rail.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      cancelMomentum();
      down = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      lastX = e.clientX;
      lastTime = performance.now();
      velocity = 0;
      samples = [];
      rail.classList.add('dragging');
    });
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onCancel);
    rail.addEventListener('click', onRailClick, true);
  }

  /* ---------- nav arrows (scroll 1 card, loop via boundary) ---------- */
  function initNavArrows(rail, row) {
    var prevBtn = rail.closest('.mypride-cult').querySelector('[data-cult-prev]');
    var nextBtn = rail.closest('.mypride-cult').querySelector('[data-cult-next]');
    if (!prevBtn || !nextBtn) return;

    function stepWidth() {
      var card = row.querySelector('.mypride-cult__card');
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(row).gap) || 0;
      return card.offsetWidth + gap;
    }

    function scrollStep(direction) {
      rail.scrollBy({ left: direction * stepWidth(), behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () { scrollStep(-1); });
    nextBtn.addEventListener('click', function () { scrollStep(1); });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(section) {
    var items = section.querySelectorAll('.rv');
    if (!items.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- init ---------- */
  function initSection(section) {
    var rail = section.querySelector('.mypride-cult__rail');
    var row = section.querySelector('.mypride-cult__row');
    if (!rail || !row) return;

    initLoop(rail, row);
    var half = getHalf(row);
    rail.scrollLeft = half;
    initDragScroll(rail, row);
    initNavArrows(rail, row);
    initReveal(section);

    var pending = null;
    function wrap() {
      pending = null;
      checkBoundary(rail, getHalf(row));
    }
    function scheduleWrap() {
      if (pending) clearTimeout(pending);
      pending = setTimeout(wrap, 120);
    }
    rail.addEventListener('scroll', scheduleWrap, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mypride-cult').forEach(initSection);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.classList.contains('mypride-cult')) {
        initSection(e.target);
      }
    });
  }
})();
